<template>
	<div class="question-bank">
		<pageTop></pageTop>
		<div class="page-content">
			<h4>自由练习&nbsp;-&nbsp;题库选择</h4>
			<ul class="f-clear">
				<li v-for="(t, i) in tikuList" :key="t.id" :class="setSubjectType(t)"
					@click="goMakeAquestion(t.id, t.tiku_name)">
					<span class="iconfont icon-gou"></span>
					{{t.tiku_name + '&nbsp;&nbsp;&nbsp;' + t.problem_number + '道'}}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import pageTop from '../components/pageTop';
	import {
		getTikuList
	} from '@/api/preliminaryClassic'
	export default {
		name: "questionBank",
		components: {
			pageTop
		},
		data() {
			return {
				tikuList: []
			}
		},
		created() {
			this.getTikuList();
		},
		mounted() {},
		computed: {
			setSubjectType() {
				return (t) => {
					if (t.is_submit) {
						if (t.is_accept) {
							return 'is-accept'
						}
						return 'is-submit'
					}
					return ''
				}
			}
		},
		methods: {
			async getTikuList() {
				let res = await getTikuList();
				this.tikuList = res.data.list;
			},
			goMakeAquestion(id, name) {
				this.$router.push({
					name: "makeAquestion",
					query: {
						type: 1,
						tikuId: id,
						tikuName: name
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.question-bank {
		.page-content {
			position: absolute;
			top: 4.2rem;
			width: calc(100% - 5.2rem);
			height: calc(100% - 6.8rem);
			color: #FFF;
			margin: 1rem 2.6rem 1.6rem;
			background-color: rgba(24, 65, 85, 0.8);

			h4 {
				padding-left: 3rem;
				font-size: 1.4rem;
				font-weight: 400;
				height: 3.8rem;
				line-height: 3.8rem;
			}

			ul {
				overflow: auto;
				height: calc(100% - 3.8rem);

				li {
					width: calc(50% - 5.2rem);
					float: left;
					margin: 0 2.6rem 1.4rem;
					text-align: center;
					background-color: #259DA7;
					font-size: 1.36rem;
					height: 2.8rem;
					line-height: 2.8rem;
					border-radius: 0.4rem;
					cursor: pointer;
					position: relative;

					.icon-gou {
						display: none;
					}
				}

				li.is-accept {
					background-color: #009D4E;

					.icon-gou {
						display: inline-block;
						position: absolute;
						color: #22FF8F;
						font-size: 2.24rem;
						left: 1.2rem;
					}
				}

				li.is-submit {
					background-color: #D29B24;

					&::after {
						content: '';
						position: absolute;
						display: inline-block;
						width: 1.12rem;
						height: 1.12rem;
						background: #FFF222;
						border-radius: 50%;
						left: 1.6rem;
						top: 0.8rem;
					}
				}
			}
		}
	}
</style>